import SetRoleModal from './set-role-modal.vue'
export default SetRoleModal
